import React from 'react';
import { IPreviewTemplateResponse } from '../../../api/IApiResponse';
import { ITemplateProjectProps } from './ITemplateProject';
import TemplateItem from './TemplateItem/TemplateItem';

const TemplateProject = (props: ITemplateProjectProps) => {
    const [selectedIndex, setSelectedIndex] = React.useState<number>(0);

    const handleClick = (template: IPreviewTemplateResponse, index: number) => {
        setSelectedIndex(index);
        props.onChange(template.id);
    };

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto',
                gap: ' 10px',
            }}>
            {props.templates.map((template, index) => (
                <TemplateItem
                    {...template}
                    onClick={() => handleClick(template, index)}
                    style={index === selectedIndex ? { border: `2px solid #004652` } : { border: '2px solid transparent' }}
                    key={template.id}
                />
            ))}
        </div>
    );
};

export default TemplateProject;
